import {Form as RBForm} from 'react-bootstrap';
import {Controller} from 'react-hook-form';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
// import CustomSelect from 'components/CustomSelect/Select2';
import classNames from './candidate-portal.module.css';
import moment from 'moment';
import {useTranslation} from 'react-i18next';
import {sortArrayList} from 'helpers/helpers';
import {DEFAULT_DATE_FORMAT} from 'helpers/constants';
import InstructionInfo from 'components/instructionInfo';
import {CustomSelect} from 'erp-react-components';

/**
 *
 * @param {object} props
 * @property {{label:string,is_mandatory:1|0,options:unknown[]}} props.field
 * @property {string} props.category_name
 * @property {object} props.control
 * @property {object} props.errors
 * @returns
 */
const FormBuilder = (props) => {
  const {t} = useTranslation();
  const {
    field,
    index,
    category_name,
    control,
    errors,
    minDate,
    customLabel,
    disable,
    dateLimit,
    placeholder,
    popperPlacement,
    trigger,
  } = props;
  const error = ((errors || {})[category_name] || {})[field['name']];
  return (
    <>
      <div
        className="awl-form-group flex-grow-1 max-width-100"
        style={{width: field.extra_fields?.length ? '70%' : ''}}
      >
        {field.fieldType === 'text' ? (
          <>
            <label className="text-capitalize" htmlFor={field.label}>
              {t(customLabel) || t(field.label)}
              {field.uId ? (
                field.mandatory ? (
                  <span className={classNames['mandatory-color']}>*</span>
                ) : null
              ) : field.is_mandatory ? (
                <span className={classNames['mandatory-color']}>*</span>
              ) : null}
            </label>
            {field?.uId && field?.description ? (
              <InstructionInfo
                style={{bottom: '3px'}}
                desc={field.description}
              />
            ) : (
              <> </>
            )}
            <Controller
              render={({field: {name, value, onChange, onBlur}}) => (
                <input
                  className={
                    'awl-form-control mr-2 ' +
                    (error ? 'has-error is-invalid' : '')
                  }
                  name={name}
                  autoComplete="new-password"
                  id={field.label}
                  type={
                    field.label == 'Current Salary' ||
                    field.label == 'Expected Salary' ||
                    field.label == 'Notice Period'
                      ? 'number'
                      : 'text'
                  }
                  min={
                    field.label == 'Current Salary' ||
                    field.label == 'Expected Salary' ||
                    field.label == 'Notice Period'
                      ? '0'
                      : ''
                  }
                  value={value}
                  disabled={disable ? true : false}
                  style={{
                    minWidth: field.name === 'notice_period' ? '5rem' : '',
                    marginRight: field.name === 'notice_period' ? '1rem' : '',
                  }}
                  onChange={(v) => onChange(v)}
                  onBlur={() => {
                    onBlur();
                    trigger && trigger(name);
                  }}
                  placeholder={placeholder || t(`Enter`)}
                />
              )}
              control={control}
              name={`${category_name}.${field.name}`}
              defaultValue={field.answer || ''}
            />
            {error && (
              <span className="text-danger text-right input-error-msg">
                {t(error.message)}
              </span>
            )}
          </>
        ) : field.fieldType === 'checkbox' ? (
          <>
            <label className="">
              {t(customLabel) || t(field.label)}
              {field.uId ? (
                field.mandatory ? (
                  <span className={classNames['mandatory-color']}>*</span>
                ) : null
              ) : field.is_mandatory ? (
                <span className={classNames['mandatory-color']}>*</span>
              ) : null}
            </label>
            {field?.uId && field?.description ? (
              <InstructionInfo
                style={{bottom: '3px'}}
                desc={field.description}
              />
            ) : (
              <> </>
            )}
            <div className="d-flex flex-wrap">
              {
                <div className="awl-custom-control awl-custom-checkbox mb-2 pl-0 multiselect-cc -flex-grow-1 mr-2">
                  <Controller
                    render={({field: {name, value, onChange, onBlur}}) =>
                      field.options.map((o) => {
                        return (
                          <div key={o.value}>
                            <input
                              className="awl-custom-control-input"
                              name={name}
                              type="checkbox"
                              value={o.value}
                              disabled={disable ? true : false}
                              checked={value ? value.includes(o.value) : value}
                              id={o.id}
                              onChange={(e) => {
                                onChange(
                                  e.currentTarget.checked
                                    ? value
                                      ? (value += `,${o.value}`)
                                      : o.value
                                    : value
                                    ? (value = value
                                        ? value
                                            .split(',')
                                            .filter((v) => v != o.value)
                                            .toString()
                                        : '')
                                    : '',
                                );
                              }}
                              onBlur={() => onBlur}
                            />
                            <label
                              className="awl-custom-control-label"
                              htmlFor={o.id}
                            >
                              {t(o.value)}
                            </label>
                          </div>
                        );
                      })
                    }
                    // defaultValue={field.answer}
                    control={control}
                    name={`${category_name}.${field.name}`}
                  />
                  {error && (
                    <span className="text-danger text-right input-error-msg">
                      {t(error.message)}
                    </span>
                  )}
                </div>
              }
            </div>
          </>
        ) : field.fieldType === 'dropdown' ? (
          <>
            <label className="">
              {t(customLabel) || t(field.label)}
              {(field.uId ? field.mandatory : field.is_mandatory) &&
              (customLabel || field.label) ? (
                <span className={classNames['mandatory-color']}>*</span>
              ) : (
                <span className="m-1"> </span>
              )}
            </label>
            {field?.uId && field?.description ? (
              <InstructionInfo
                style={{bottom: '3px'}}
                desc={field.description}
              />
            ) : (
              <> </>
            )}
            <Controller
              render={({field: {name, value, onChange, onBlur}}) => (
                <CustomSelect
                  multiSelect={field.multi}
                  checkbox={field.multi ? true : false}
                  searchable={true}
                  name={name}
                  searchOptions={
                    field.options.length > 1 || field.multi ? true : false
                  }
                  options={
                    field.options.length
                      ? sortArrayList(
                          field.options.map((m) =>
                            m?.name ? {label: m?.name, value: m?.value} : m,
                          ),
                        )
                      : []
                  }
                  disabled={disable ? true : false}
                  customClass={
                    field?.name == 'notice_period_unit select-white-bg '
                      ? `${
                          error
                            ? 'is-invalid select-white-bg '
                            : ' select-white-bg '
                        } ${classNames['np-unit-select']}`
                      : `${
                          error
                            ? 'is-invalid select-white-bg '
                            : ' select-white-bg '
                        }`
                  }
                  placeholder={placeholder || t('Select')}
                  value={value && field.multi ? value.split(',') : value}
                  onChange={(val) => {
                    onChange(field.multi ? val.toString() : val);
                  }}
                  onBlur={() => onBlur}
                />
              )}
              control={control}
              name={`${category_name}.${field.name}`}
              // defaultValue={field.answer || ''}
            />
            {error && (
              <span className="text-danger text-right input-error-msg">
                {t(error.message)}
              </span>
            )}
          </>
        ) : field.fieldType === 'radio' ? (
          <>
            <label className="">
              {t(customLabel) || t(field.label)}
              {field.uId ? (
                field.mandatory ? (
                  <span className={classNames['mandatory-color']}>*</span>
                ) : null
              ) : field.is_mandatory ? (
                <span className={classNames['mandatory-color']}>*</span>
              ) : null}
            </label>
            {field?.uId && field?.description ? (
              <InstructionInfo
                style={{bottom: '3px'}}
                desc={field.description}
              />
            ) : (
              <> </>
            )}
            <div className="d-flex flex-wrap">
              <Controller
                render={({field: {name, value, onChange, onBlur}}) => {
                  return (field.options || []).map((o) => {
                    return (
                      <RBForm.Check
                        key={o.id}
                        type="radio"
                        id={o.id}
                        name={name}
                        value={o.value}
                        disabled={disable ? true : false}
                        checked={o.value === value ? true : false}
                        // defaultChecked={field.answer === "1" ? "Yes" : "No"}
                        label={o.label}
                        style={{
                          marginBottom: '0.5rem',
                          paddingRight: '1.25rem',
                          paddingLeft: '0',
                        }}
                        onChange={(v) => onChange(o.value)}
                      />
                    );
                  });
                }}
                control={control}
                name={`${category_name}.${field.name}`}
              />
            </div>
            {error && (
              <span className="text-danger text-right input-error-msg">
                {t(error.message)}
              </span>
            )}
          </>
        ) : field.fieldType === 'date' ? (
          <>
            <label className="awl-form-group-label">
              {t(customLabel) || t(field.label)}
              {field.uId ? (
                field.mandatory ? (
                  <span className={classNames['mandatory-color']}>*</span>
                ) : null
              ) : field.is_mandatory ? (
                <span className={classNames['mandatory-color']}>*</span>
              ) : null}
            </label>
            {field?.uId && field?.description ? (
              <InstructionInfo
                style={{bottom: '3px'}}
                desc={field.description}
              />
            ) : (
              <> </>
            )}
            <div className="mb-4 awl-datepicker">
              <Controller
                control={control}
                name={`${category_name}.${field.name}`}
                className="awl-form-control awl_date"
                render={({field: {name, value, onChange, onBlur}}) => {
                  return (
                    <DatePicker
                      popperProps={{
                        positionFixed: true,
                      }}
                      selected={
                        value === 'Invalid date' ||
                        value === 'Invalid Date' ||
                        !value
                          ? null
                          : typeof value == 'string'
                          ? new Date(value)
                          : value
                      }
                      name={name}
                      id={name}
                      autoComplete="new-password"
                      disabled={disable ? true : false}
                      className={
                        // error
                        //   ? 'awl-form-control awl_date validationErr'
                        //   :
                        'awl-form-control awl_date'
                      }
                      onBlur={onBlur}
                      onChange={onChange}
                      dateFormat={DEFAULT_DATE_FORMAT}
                      placeholderText={placeholder || t(`Select`)}
                      popperPlacement={popperPlacement || 'bottom'}
                      // maxDate={
                      //   dateLimit == 'experience' ||
                      //   field.name == 'date_of_birth'
                      //     ? new Date()
                      //     : moment(new Date()).add(3, 'months').toDate()
                      // }
                      scrollableYearDropdown={true}
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      // minDate={minDate}
                      // minDate={field.label != 'Date Of Birth' ? moment(new Date()).toDate() : ""}
                      yearDropdownItemNumber={25}
                    />
                  );
                }}
                // defaultValue={
                //   field.label != 'Date Of Birth'
                //     ? field.answer
                //       ? moment(
                //           field.answer === 'Invalid date' ||
                //             field.answer === 'Invalid Date'
                //             ? ''
                //             : field.answer,
                //         ).toDate()
                //       : moment(new Date()).toDate()
                //     : ''
                // }
              />
              {error && (
                <span className="mb-2 text-danger text-right input-error-msg">
                  {t(error.message)}
                </span>
              )}
            </div>
          </>
        ) : field.fieldType === 'textarea' ? (
          <>
            <label className="">
              {t(customLabel) || t(field.label)}
              {field.uId ? (
                field.mandatory ? (
                  <span className={classNames['mandatory-color']}>*</span>
                ) : null
              ) : field.is_mandatory ? (
                <span className={classNames['mandatory-color']}>*</span>
              ) : null}
            </label>
            {field?.uId && field?.description ? (
              <InstructionInfo
                style={{bottom: '3px'}}
                desc={field.description}
              />
            ) : (
              <> </>
            )}
            <Controller
              render={({field: {name, value, onChange, onBlur}}) => (
                <textarea
                  className={
                    'awl-form-control ' + (error ? 'has-error is-invalid' : '')
                  }
                  name={name}
                  value={value}
                  autoComplete="new-password"
                  disabled={disable ? true : false}
                  onChange={(v) => onChange(v)}
                  onBlur={() => onBlur}
                  placeholder={placeholder || t(`Enter `)}
                ></textarea>
              )}
              control={control}
              name={`${category_name}.${field.name}`}
              defaultValue={field.answer || ''}
            />
            {error && (
              <span className="text-danger text-right input-error-msg">
                {t(error.message)}
              </span>
            )}
          </>
        ) : field.fieldType === 'toggle' || field.fieldType === 'switch' ? (
          <>
            <div className="awl-form-group mx-2">
              <label className="text-capitalize text-nowrap ">
                {t(customLabel) || t(field.label)}
                {field.uId ? (
                  field.mandatory ? (
                    <span className={classNames['mandatory-color']}>*</span>
                  ) : null
                ) : field.is_mandatory ? (
                  <span className={classNames['mandatory-color']}>*</span>
                ) : null}
              </label>
              {field?.uId && field?.description ? (
                <InstructionInfo
                  style={{bottom: '3px'}}
                  desc={field.description}
                />
              ) : (
                <> </>
              )}
              <div
                className={
                  'd-flex language-switch ' + classNames.smallSwitchLanguage
                }
              >
                <div
                  className="leavetype-toggle-switch left-part-names mb-0 d-flex"
                  style={{bottom: '0'}}
                >
                  <label className={'switch ' + classNames.smallSwitchLabel}>
                    <Controller
                      render={({field: {name, value, onChange, onBlur}}) => (
                        <input
                          className="awl-form-control"
                          type="checkbox"
                          id="is_negotiable"
                          name={name}
                          value={value}
                          disabled={disable ? true : false}
                          //defaultChecked={value}
                          checked={value == '1'}
                          onChange={(e) =>
                            onChange(e.currentTarget.checked ? '1' : '0')
                          }
                          onBlur={() => onBlur}
                        />
                      )}
                      // defaultValue={field.answer}
                      control={control}
                      name={`${category_name}.${field.name}`}
                    />
                    <span
                      className={'slider round ' + classNames.smallSwitchSlider}
                    >
                      <p className="mb-0 switch-on"> {t('ON')}</p>
                      <p className="mb-0 switch-off">{t('OFF')}</p>
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
      </div>

      {field.extra_fields?.length ? (
        <>
          <div style={{width: '0.5rem'}}></div>
          {(field.extra_fields ?? []).map((f) => {
            return (
              <>
                <FormBuilder
                  key={f.id || f.name}
                  field={{
                    ...f,
                    is_mandatory: field.is_mandatory, // Take main field's mandatory values
                    label: [
                      'current_salary_cycle',
                      'expected_salary_cycle',
                      'notice_period_unit',
                    ].includes(f.name)
                      ? ''
                      : f.label,
                  }}
                  index={''}
                  category_name={category_name}
                  control={control}
                  errors={errors}
                />
              </>
            );
          })}
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default FormBuilder;
